import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import type { Id } from "@/convex/_generated/dataModel";
import { REVIEW_TABS, ReviewDetailPage, type DetailTab } from "@/components/collection-apps/review/review-detail";

// Super administrador → Apps → revisar una versión (inspección completa y decisión).
export const Route = createFileRoute("/_super/super/apps/$versionId")({
  validateSearch: z.object({
    tab: z.string().optional(),
  }),
  component: AppReviewRoute,
});

function AppReviewRoute() {
  const { versionId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const current = (REVIEW_TABS as string[]).includes(tab ?? "") ? (tab as DetailTab) : "summary";
  return (
    <ReviewDetailPage
      key={versionId}
      versionId={versionId as Id<"app_versions">}
      tab={current}
      onTab={(t) => void navigate({ search: { tab: t === "summary" ? undefined : t }, replace: true })}
    />
  );
}
